/**
 * Resolve the WebSocket URL for a given route (e.g. "/dashboard/sockets").
 *
 * Prefer owned API Gateway WebSocket:
 *   REACT_APP_WS_URL / VITE_WS_URL = wss://xxxx.execute-api.eu-central-1.amazonaws.com/prod
 *
 * Fallback (legacy): GAE Express host used historically for clock in/out.
 * Opt-in host override: REACT_APP_SOCKET_HOST / VITE_SOCKET_HOST
 */
export const getSocketUrl = (route) => {
  const viteEnv =
    typeof import.meta !== "undefined" && import.meta.env
      ? import.meta.env
      : {};

  const fullUrl = process.env.REACT_APP_WS_URL || viteEnv.VITE_WS_URL;

  if (fullUrl) {
    // API GW WebSocket URL is the stage root; ignore legacy /hr route suffix.
    return String(fullUrl).replace(/\/$/, "");
  }

  const socketProtocol =
    typeof window !== "undefined" && window.location?.protocol === "https:"
      ? "wss:"
      : "ws:";
  const prodHost = "leadmanager-express-backend.ue.r.appspot.com";
  const viteHost = viteEnv.VITE_SOCKET_HOST;
  const host =
    process.env.REACT_APP_SOCKET_HOST || viteHost || prodHost;
  const path = route?.startsWith("/") ? route : `/${route || ""}`;
  return `${socketProtocol}//${host}/hr${path}`;
};
